<template>
  <footer class="m-grid__item		m-footer footer">
    <div class="m-container m-container--fluid m-container--full-height m-page__container">
      <div class="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
        <div class="m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last">
        </div>
        <div class="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
          <ul class="m-footer__nav m-nav m-nav--inline m--pull-right">
            <li v-if="termsPageUuid" class="m-nav__item ls">
              <router-link :to="{name: 'CustomPage', params: {pageUuid: 'terms'}}" class="m-nav__link">
                <span class="m-nav__link-text">{{ $t('Terms of use') }}</span>
              </router-link>
            </li>
            <li class="m-nav__item ls">
              <router-link :to="{name: 'PrivacyPolicyPage'}" class="m-nav__link">
                <span class="m-nav__link-text">{{ $t('Privacy policy') }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "Bar",
    computed: {
      ...mapState({
        termsPageUuid: state => state.settings.termsPageUuid,
        privacyPageUuid: state => state.settings.privacyPageUuid
      }),
    }
  }
</script>

<style scoped>
  .m-nav .m-nav__item.ls:hover:not(.m-nav__item--disabled) > .m-nav__link .m-nav__link-text {
    color: var(--accent-color) !important;
  }

  .footer {
    margin-left: 0 !important;
  }

  @media (max-width: 767px) {
    .footer {
      min-height: unset !important;
    }
  }
</style>
